<template lang="pug">
.userError
  .row
    .col-md-6.col-md-offset-3
      .jumbotron
        h2 Błąd!
        h3.text-danger {{errorMsg}}
        .btn.btn-primary.pull-right(@click.prevent="goToLogin()") Logowanie
        br
        br
</template>
<script>
export default {
  data () {
    return {
      errorMsgs: {
        'User not registered.': 'Nie ma takiego użytkownika.',
        'Invalid user or password!': 'Niepoprawny użytkownik lub hasło.'
      }
    }
  },
  methods: {
    goToLogin () {
      this.$router.push({name: 'userLogin'})
    }
  },
  computed: {
    errorMsg () {
      return this.errorMsgs[this.$route.query.error]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserLoginError.vue